import React from "react";
import { useStyles } from "./style";
import { Button } from "@material-ui/core";

const ActionButtons = ({
  handleCancel,
  handleProceed,
  disabled,
  proceedBtnText,
  cancelBtnText,
  showProceedBtn = true,
  disabledCancelBtn = false,
}) => {
  const classes = useStyles();
  return (
    <div
      className={
        showProceedBtn
          ? "d-flex align-items-center justify-content-center  w-100"
          : "d-flex justify-content-center w-100"
      }
      style={{ gap: "16px" }}
    >
      <Button
        type="button"
        className={classes.cancelBtn}
        onClick={handleCancel}
        disabled={disabledCancelBtn}
      >
        {cancelBtnText || "Cancel"}
      </Button>
      {showProceedBtn && (
        <Button
          type="button"
          className={classes.proceedBtn}
          onClick={handleProceed}
          disabled={disabled}
        >
          {proceedBtnText || "Proceed"}
        </Button>
      )}
    </div>
  );
};
export default ActionButtons;
